import axios from '@/libs/api.request'

// 搜索页分页查询
export const getSearchPageList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/search/page'
  })
}

// 添加搜索页配置
export const addSearchPage = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/search/page'
  })
}

// 修改搜索页配置
export const editSearchPage = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/search/page'
  })
}

// 根据ID获取搜索页配置详情
export const getSearchPageInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/search/page/' + id
  })
}

// 切换搜索页启用状态
export const changeSearchPageStatus = (id) => {
  return axios.request({
    method: 'put',
    url: '/search/page/' + id
  })
}

// 删除搜索页配置
export const delSearchPage = (id) => {
  return axios.request({
    method: 'delete',
    url: '/search/page/' + id
  })
}

// 分页查询搜索页中的短剧列表
export const getSearchPagePlay = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/search/page/play'
  })
}

// 向搜索页加入短剧
export const addSearchPagePlay = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/search/page/play'
  })
}

// 编辑搜索页中短剧排序值
export const editSearchPagePlay = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/search/page/play'
  })
}

// 从搜索页中删除短剧
export const delSearchPagePlay = (data) => {
  return axios.request({
    method: 'delete',
    data,
    url: '/search/page/play'
  })
}

// 批量向搜索页加入短剧（保持顺序）
export const batchAddSearchPagePlay = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/search/page/play/batch'
  })
}

// 分页查询不在搜索页中的短剧列表
export const getSearchPagePlayNotIn = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/search/page/play/notIn'
  })
}

// 根据语言、剧名、标签等条件查询短剧（返回标签名称和是否已添加状态）
export const getSearchPagePlayPageByCondition = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/search/page/play/pageByCondition'
  })
}

// 移动编辑搜索页中短剧排序值或一键置顶
export const editSearchPagePlaySort = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/search/page/play/sort'
  })
}

// 搜索页短剧置顶开启与取消
export const changeSearchPagePlaySticky = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/search/page/play/sticky'
  })
}

// 获取搜索页短剧TOP 100榜单
export const getSearchPagePlayTop100 = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/search/page/play/top100'
  })
}